module.exports = __webpack_public_path__ + "img/icon_intelligence_communication.98e5dec7.png";